import { render, staticRenderFns } from "./OrderListV2.vue?vue&type=template&id=2dd79a10&scoped=true"
import script from "./OrderListV2.vue?vue&type=script&lang=js"
export * from "./OrderListV2.vue?vue&type=script&lang=js"
import style0 from "./OrderListV2.vue?vue&type=style&index=0&id=2dd79a10&prod&lang=scss&scoped=true"
import style1 from "./OrderListV2.vue?vue&type=style&index=1&id=2dd79a10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd79a10",
  null
  
)

/* custom blocks */
import block0 from "./OrderListV2.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)
import block1 from "@/locales2/share/datetime.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fusr%2Fsrc%2Fapp%2Fsrc%2Fonwheel%2Fpages%2FOrderListV2.vue&external"
if (typeof block1 === 'function') block1(component)

export default component.exports